import React, { useState, useEffect } from 'react'
import { Typography, Stack, useTheme, useMediaQuery, Box } from '@mui/material'
import { DataGrid } from 'Components/LifeDataGrid'
import { makeGetRequest } from '../../../utils/api'
import { useNavigate } from 'react-router-dom'
import { convertToUserDateFormate } from 'utils/helpers'
import { useSelector } from 'react-redux'

function PlantList({ fetchOperations, setSelectedRows, operations }) {
  const siteUser = useSelector((store) => store.user)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [modifiedColumns, setModifiedColumns] = useState([])

  // const [myPlants, setMyPlants] = useState({ count: 0, results: [] });
  // const [selectedRows, setSelectedRows] = useState([]);
  const [rows, setRows] = useState(10)
  const [page, setPage] = useState(0)
  let navigate = useNavigate()

  const handleRowsChange = (params) => {
    setRows(params.pageSize)
    // setMyPlants({ ...myPlants, page_size: params.pageSize });
  }

  const handlePageChange = (params) => {
    setPage(params.page)
    // setMyPlants({ ...myPlants, page: params.page });
  }
  useEffect(() => {
    if (isMobile) {
      setModifiedColumns([
        {
          field: 'Nom',
          headerName: 'Nom',
          // width: 210,
          flex: 1,
          // valueGetter: (params) => `${params.row.Nom?.Nom || params.row.IBAN}`,
          renderCell: (params) => (
            <Box py={1}>
              <Box fontWeight={600}>{params.value?.Nom}</Box>
              <Box>
                <Box component={'span'}>Prochain arrosage:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {convertToUserDateFormate(siteUser.user, params.row.nextWat)}
                </Box>
              </Box>
              <Box>
                <Box component={'span'}>Prochaine fertilisation:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {convertToUserDateFormate(siteUser.user, params.row.nextFert)}
                </Box>
              </Box>
              <Box>
                <Box component={'span'}>Prochain rempotage:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {convertToUserDateFormate(siteUser.user, params.row.nextRempot)}
                </Box>
              </Box>
              <Box>
                <Box component={'span'}>Emplacement:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {params.row.Emplacement}
                </Box>
              </Box>
            </Box>
          ),
        },
      ])
    } else {
      setModifiedColumns(columns)
    }
  }, [isMobile])
  const columns = [
    {
      field: 'Logo',
      headerName: 'Image',
      width: 75,
      renderCell: (params) => <img src={params.row.Nom?.Logo} alt="Plant" />,
    },
    {
      field: 'Nom',
      headerName: 'Nom',
      width: 140,
      type: 'text',
      renderCell: (params) => params.value?.Nom,
    },
    { field: 'Nombre', headerName: 'Nombre', width: 75 },
    { field: 'CultureType', headerName: 'Type de culture', width: 100 },
    {
      field: 'LastWat',
      headerName: 'Dernier arrosage',
      width: 125,
      valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.LastWat),
    },
    {
      field: 'nextWat',
      headerName: 'Prochain arrosage',
      width: 150,
      valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.nextWat),
    },
    {
      field: 'LastFert',
      headerName: 'Dernière fertilisation',
      width: 150,
      valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.LastFert),
    },
    {
      field: 'nextFert',
      headerName: 'Prochaine fertilisation',
      width: 175,
      valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.nextFert),
    },
    {
      field: 'LastRempot',
      headerName: 'Dernier rempotage',
      width: 150,
      valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.LastRempot),
    },
    {
      field: 'nextRempot',
      headerName: 'Prochain rempotage',
      width: 150,
      valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.nextRempot),
    },
    { field: 'Emplacement', headerName: 'Emplacement', width: 100 },
  ]

  return (
    <div
      style={{
        width: '100% ',
        background: 'white',
        borderRadius: '5px',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        Mes Plantes ({operations.count})
      </Typography>
      <DataGrid
        sx={{
          height: 600,
          fontSize: isMobile ? '11px' : '13px',
        }}
        rows={operations.results ? operations.results : []}
        columns={modifiedColumns}
        pageSize={rows}
        getRowHeight={() => (isMobile ? 'auto' : 50)}
        rowCount={operations.count ? operations.count : 0}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        pagination
        checkboxSelection
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        onRowClick={(e) => navigate(`/Mesplantes/detail/${e.row.id}`)}
        components={{
          NoRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              Aucune donnée trouvée
            </Stack>
          ),
          NoResultsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              Aucune donnée trouvée
            </Stack>
          ),
        }}
      />
    </div>
  )
}

export default PlantList
